import { eventTypeStandard } from './internal/core';
import { pushWithGlobalSale } from './internal/pushWithGlobal';

export type UseTrackingDepositReturn = {
    trackDepositFormInteraction: (fieldName: string) => void;
    trackDepositModalView: VoidFunction;
    trackDepositFormError: (errorType: string) => void;
    trackDepositSuccess: VoidFunction;
    trackDepositEmailClick: VoidFunction;
    trackDepositCloseIconClick: VoidFunction;
    trackDepositBindSecurityDepositButton: VoidFunction;
    trackDepositModalExit: VoidFunction;
    trackDepositPaymentMethodAvailable: VoidFunction;
    trackDepositAddPaymentMethod: VoidFunction;
    trackDepositPaypalButton: VoidFunction;
    trackDepositGooglePayButton: VoidFunction;
};

export const useTrackingDeposit = (): UseTrackingDepositReturn => ({
    trackDepositFormInteraction(fieldName): void {
        pushWithGlobalSale(sales => ({
            event: 'click',
            click_element: 'field',
            click_text: fieldName,
            page_type: 'deposit',
            sales,
            ...eventTypeStandard,
        }));
    },

    trackDepositModalView(): void {
        pushWithGlobalSale(sales => ({
            event: 'modal_view',
            page_type: 'deposit',
            sales,
            ...eventTypeStandard,
        }));
    },

    trackDepositModalExit(): void {
        pushWithGlobalSale(sales => ({
            event: 'modal_exit',
            page_type: 'deposit',
            sales,
            ...eventTypeStandard,
        }));
    },

    trackDepositBindSecurityDepositButton(): void {
        pushWithGlobalSale(sales => ({
            event: 'click',
            click_element: 'button',
            click_text: 'bind_security_deposit',
            page_type: 'deposit',
            sales,
            ...eventTypeStandard,
        }));
    },

    trackDepositCloseIconClick(): void {
        pushWithGlobalSale(sales => ({
            event: 'click',
            click_element: 'icon',
            click_text: 'exit',
            page_type: 'deposit',
            sales,
            ...eventTypeStandard,
        }));
    },

    trackDepositEmailClick(): void {
        pushWithGlobalSale(sales => ({
            event: 'click',
            click_element: 'email',
            click_text: 'contact_customer_service',
            page_type: 'deposit',
            sales,
            ...eventTypeStandard,
        }));
    },

    trackDepositSuccess(): void {
        pushWithGlobalSale(sales => ({
            event: 'deposit',
            page_type: 'deposit',
            sales,
            ...eventTypeStandard,
        }));
    },

    trackDepositFormError(errorType): void {
        pushWithGlobalSale(sales => ({
            event: 'form_error',
            error_type: errorType,
            page_type: 'deposit',
            sales,
            ...eventTypeStandard,
        }));
    },

    trackDepositPaymentMethodAvailable(): void {
        pushWithGlobalSale(sales => ({
            event: 'click',
            click_element: 'button',
            click_text: 'payment_method_available',
            page_type: 'deposit',
            sales,
            ...eventTypeStandard,
        }));
    },

    trackDepositAddPaymentMethod(): void {
        pushWithGlobalSale(sales => ({
            event: 'click',
            click_element: 'button',
            click_text: 'add_payment_method',
            page_type: 'deposit',
            sales,
            ...eventTypeStandard,
        }));
    },

    trackDepositPaypalButton(): void {
        pushWithGlobalSale(sales => ({
            event: 'click',
            click_element: 'button',
            click_text: 'paypal',
            page_type: 'deposit',
            sales,
            ...eventTypeStandard,
        }));
    },

    trackDepositGooglePayButton(): void {
        pushWithGlobalSale(sales => ({
            event: 'click',
            click_element: 'button',
            click_text: 'google_pay',
            page_type: 'deposit',
            sales,
            ...eventTypeStandard,
        }));
    },
});
